import { Autocomplete, IconButton, Stack, TextField } from "@mui/material";
import { useState } from "react";
import useSearchLocations from "hooks/api/useSearchLocations";
import DeleteIcon from "@mui/icons-material/Delete";

export const LocationPicker = ({
    value,
    label,
    handleRemoveLocation,
    handlePickLocation,
    type,
    index,
}) => {
    const [inputValue, setInputValue] = useState(value?.title || "");
    const [isAutocompleteDisabled, setIsAutocompleteDisabled] = useState(false);

    const {
        isSearchLocationsLoading,
        locations,
        fetchLocations,
        setLocations,
    } = useSearchLocations({ relocationSearch: true });

    const handleChangeInput = (event, inputValue) => {
        if (event.type !== "change") {
            return;
        }
        fetchLocations(inputValue);
    };

    return (
        <>
            <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <Autocomplete
                    value={value?.title ? value?.title : null}
                    fullWidth
                    multiple={false}
                    loading={isSearchLocationsLoading}
                    loadingText="Loading locations..."
                    open={!isAutocompleteDisabled}
                    inputValue={inputValue}
                    onInputChange={(e, v) => {
                        if (isAutocompleteDisabled) {
                            return;
                        }
                        setInputValue(v);
                    }}
                    filterOptions={(x) => x}
                    noOptionsText={"No locations found"}
                    options={isAutocompleteDisabled ? [] : locations}
                    onChange={(_, value) => {
                        if (value === null || value === undefined) {
                            handlePickLocation(type, index, {});
                            setInputValue("");
                            setIsAutocompleteDisabled(false);
                            setLocations([]);
                            return;
                        }
                        setIsAutocompleteDisabled(true);
                        handlePickLocation(type, index, value);
                    }}
                    freeSolo={true}
                    getOptionLabel={(option) =>
                        typeof option === "string" ? option : option.title
                    }
                    isOptionEqualToValue={(option, value) => {
                        if (
                            typeof option === "string" &&
                            typeof value === "string"
                        ) {
                            return option === value;
                        }
                        if (
                            typeof option !== "string" &&
                            typeof value !== "string"
                        ) {
                            return option.title === value.title;
                        }
                        return false;
                    }}
                    sx={{
                        "& .MuiAutocomplete-popupIndicator": {
                            display: isAutocompleteDisabled
                                ? "none"
                                : undefined,
                        },
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label || "Location"}
                            onChange={(e) => {
                                if (isAutocompleteDisabled) {
                                    return;
                                }
                                handleChangeInput(e, e.target.value);
                            }}
                        />
                    )}
                    renderOption={(props, option) => (
                        <li {...props} key={option.title}>
                            {option.title}
                        </li>
                    )}
                />
                <IconButton aria-label="Delete" onClick={handleRemoveLocation}>
                    <DeleteIcon />
                </IconButton>
            </Stack>
        </>
    );
};

export default LocationPicker;
